// utils/loadGoogleMapsScript.ts
export const loadGoogleMapsScript = (apiKey: string): Promise<void> => {
    return new Promise((resolve, reject) => {
      if (typeof window.google === 'object' && typeof window.google.maps === 'object') {
        // Already loaded
        resolve();
        return;
      }
  
      const script = document.createElement('script');
      script.src = `https://maps.googleapis.com/maps/api/js?key=${apiKey}&libraries=places`;
      script.async = true;
      script.defer = true;
  
      script.onload = () => {
        resolve();
      };
  
      script.onerror = (err) => {
        reject(err);
      };
  
      document.head.appendChild(script);
    });
  };
  